import { createContext } from 'use-context-selector';
import { IOpporunitiesContext } from './OpportunitiesContext.types';
import { opportunitiesDefaultStates } from './OpportunitiesDefaultStates';

export const OpportunitiesContext = createContext<IOpporunitiesContext>(opportunitiesDefaultStates);
